import * as Joi from 'joi';

export interface ValidCeqTestDateFormData {
  firstAcceptedCeqTestDate: string;
  lastAcceptedCeqTestDate: string;
}

export const ValidCeqTestDateSchema = Joi.object({
  firstAcceptedCeqTestDate: Joi.date().required().messages({
    'date.base': 'First accepted CEQ test date is not allowed to be empty',
    'any.required': 'First accepted CEQ test date is not allowed to be empty',
  }),
  lastAcceptedCeqTestDate: Joi.date().min(Joi.ref('firstAcceptedCeqTestDate')).required().messages({
    'date.base': 'Last accepted CEQ test date is not allowed to be empty',
    'date.min': 'Last accepted CEQ test date must be greater than First Accepted CEQ Test Date',
    'any.required': 'Last accepted CEQ test date is not allowed to be empty',
  }),
});
